import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../../components/button';
import './SubmitConfirmationModal.css';

function SubmitConfirmationModal({
  show,
  selectedSingtelShops = [],
  selectedSerShops = [],
  onConfirm,
  onCancel
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header>
        <Modal.Title>Submit Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to apply the discount to the following shops?</p>

        <div className="shop-columns">
          <div className="shop-column singtel-column">
            <h5>Singtel</h5>
            {selectedSingtelShops.length > 0 ? (
              <ul>
                {selectedSingtelShops.map(shop => (
                  <li key={shop.value}>{shop.label}</li>
                ))}
              </ul>
            ) : (
              <p>No shops selected</p>
            )}
          </div>

          <div className="shop-column ser-column">
            <h5>SER</h5>
            {selectedSerShops.length > 0 ? (
              <ul>
                {selectedSerShops.map(shop => (
                  <li key={shop.value}>{shop.label}</li>
                ))}
              </ul>
            ) : (
              <p>No shops selected</p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className='upload-btn' onClick={onConfirm}>YES, SUBMIT</Button>
        <Button className='upload-btn' onClick={onCancel}>CANCEL</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SubmitConfirmationModal;